import React from 'react'
import { Form } from 'react-bootstrap'
import useCourses from '../../../hooks/use-courses'
import IDSelector from '../../common/id-selector'

const ExperienceParam = ({
    startDate,
    endDate,
    hour,
    label,
    value,
    onChange = () => {},
}) => {

   
    const {
        isLoading,
        courses
    } = useCourses({
        limit: 50,
        filters: {
            startDate,
            endDate,
            hours: hour ? [hour] : undefined,
        }
    })
    const getPlaceholder = () => {
        if (isLoading) {
            return 'Loading experiences...'
        }
        if (!startDate) {
            return '- Start Date Required -'
        }
        if (!endDate) {
            return '- End Date Required -'
        }
        return 'Select Experience'
    }

    const disabled = !startDate || !endDate || isLoading
    
    return (
        <Form.Group>
            <Form.Label>{label || 'Experience'}</Form.Label>
            <IDSelector
                items={courses.map(c => ({ id: c.id, name: c.name}))}
                value={value}
                onChange={onChange}
                placeholder={getPlaceholder()}
                disabled={disabled}
            />
        </Form.Group>
    )
}

export default ExperienceParam